<template>
  <div class="container">


    <v-dialog
      v-model="notice"
      fullscreen 
      persistent :overlay="false"
      transition="dialog-transition"
    >
    <div class= "dialog_body mt-5">
      <v-card>
      <div >
        <v-card-title title  >
          <v-flex xs12 text-xs-center>
          <p class="font-weight-bold" style="font-size: 2em; text-decoration: underline;">❗️Verification revoquée❗️</p>
          </v-flex>
        </v-card-title>
       <v-card-text>
        <v-flex xs12 text-xs-center>
          <p class="font-weight-bold" style="font-size: 1.2em">
            Cher partenaire , votre vérification a été révoquée suite à une inconformité dans les documents et informations fournies auparavant,<br>
            Nous allons vous demander de soumettre les documents et informations  à nouveau afin que vos informations <br> puissent être en conformité avec les nouvelles exigences
            Nous nous excusons des désagréments causés, <br> merci pour votre compréhension
            </p>

            <br>
            <v-btn class="my-5" large color="success"  @click="set_step">proceder à la verification</v-btn> <br>
            
          <v-btn class="mt-5" color="primary" @click="notice = false">FERMER</v-btn>
        </v-flex>
       </v-card-text>
      </div>
     </v-card>
    </div>
    </v-dialog>




    <v-flex xs12 text-xs-center v-if="!show_verification">
      <v-card>
        <v-btn class="my-5" large color="success"  @click="set_step">proceder à la verification</v-btn> <br>
         <v-btn class="my-5" small color="secondary" router to="/dashboard/account">Retour</v-btn>
      </v-card>
      
    </v-flex>

    <div v-if="show_verification">
        <v-stepper v-model="step" v-if="!verified&&!awaiting&&!submited">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1"
              >informations</v-stepper-step
            >
            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2"
              >Documment d'identité</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step step="3">Selfie</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-5" min-height="200px">
                <v-card-title primary-title class="title">
                  informations Personnelles
                </v-card-title>
                
                <v-card-text>
                  <div class="center grid">
                    <v-layout row wrap>
                      <v-flex xs12 md6 px-3>
                        <v-text-field
                          
                          label="Nom"
                          v-model="lastName"
                        ></v-text-field>
                        <v-text-field
                          label="Prenom"
                          v-model="firstName"
                        ></v-text-field>
                        

                        <v-text-field
                          
                          label="Numero de la pièce d'identité" 
                          v-model="id_number"
                        ></v-text-field>
                      </v-flex>
                      
                      <v-flex xs12 md6 px-3 pt-4>
                        <VuePhoneNumberInput size="lg" :fetch-country="fetch_country" :translations="translations" @update="input_data" v-model="value" />
                        
                        <p class="pt-3">PAYS: {{country}}</p>
                        <v-text-field
                          
                          label="Ville"
                          v-model="city"
                        ></v-text-field>
                        
                        
                      </v-flex>
                    </v-layout>
                  </div>

                
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" :disabled ='!valid_phone' :loading ='loading' @click="submit_info"> suivant </v-btn>
                </v-card-actions>
              </v-card>
 
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card class="mb-5" color="grey lighten-1" min-height="200px">
                <v-card-title primary-title class="title">
                  Veuillez soumettre votre piece d'identité
                </v-card-title>
                <v-card-text>
                  <div style="max-width: 300px;">
                    <vue-dropzone ref="myVueDropzone"   id="dropzone" :options="dropzoneOptions"  @vdropzone-file-added="fileAdded" @vdropzone-complete="successResponse" @vdropzone-sending='sending'></vue-dropzone>
                  </div>
                  
                </v-card-text>
                <v-card-actions>
                  <v-btn color="success" @click="send_recto"> Envoyer </v-btn>
                </v-card-actions>
              </v-card>
              
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-5" color="grey lighten-1">
                <v-card-title primary-title class="title">
                  Selfie tenant votre piece d'identité et un papier sur lequel <br>
                  vous mentionnez HIROPAY et la date du jour
                  <p style="color: rgb(139, 88, 98);">NB : sans le papier sur lequel vous ecrivez HIROPAY et la date du jour, votre compte ne sara pas validé</p>
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 md4 px-3>
                      <div style="max-width: 400px;" class="mb-5">
                        <vue-dropzone ref="myVueDropzone_selfie"   id="dropzone_selfie" :options="dropzoneOptions"  @vdropzone-file-added="fileAdded_selfie" @vdropzone-complete="successResponse_selfie" @vdropzone-sending='sending_selfie'></vue-dropzone>
                      </div>
                      <v-btn  color="success" @click="send_selfie"> Envoyer </v-btn>
                    </v-flex>
                    <v-flex xs12 md8 px-3 py-3>

                      <v-layout row wrap>
                        <v-flex xs12 md6 px-3>
                          <p class="title">Exemple de selfie</p>
                            <img src="/img/selfie1.png" width="300" alt="">
                        </v-flex>
                        <v-flex xs12 md6 px-3 py-3>
                          <img src="/img/selfie2.png" width="300" alt="">
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  
                </v-card-text>
                
              </v-card>

            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

          <div >
              <v-flex xs12 text-xs-center>
                <v-card v-if="awaiting">
                    <img src="/img/relax.svg" width="300" alt="relax">
                  <v-alert
                  :value="true"
                  type="warning"
                >
                  Veuillez patienter Vos documents sont en cours de verification....
                </v-alert>
                <v-btn class="my-5" color="primary" router to="/dashboard/account">Retour</v-btn>
                </v-card>

                <v-card v-if="verified">
                  <v-flex xs12 text-xs-center>
                    <img src="/img/success.svg" width="200" alt="relax">
                  <v-alert
                  :value="true"
                  type="success"
                >
                  Félicitations votre compte est verifié, utilisez HIROPAY sans aucune restriction
                </v-alert>
                
                  </v-flex>
                  <v-btn class="my-5" color="primary" router to="/dashboard/account">Retour</v-btn>
                </v-card>
                 <v-card v-if="submited &&!awaiting">
                    <img src="/img/relax.svg" width="300" alt="relax">
                  <v-alert
                  :value="true"
                  type="warning"
                >
                  Veuillez patienter Vos documents sont en cours de verification....
                </v-alert>
                <v-btn class="my-5" color="primary" router to="/dashboard/account">Retour</v-btn>
                </v-card>
                
              </v-flex>
          </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import firebase from '../fb'
import db from '../db'
import {mapActions,mapGetters,mapState} from 'vuex'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

let server = 'https://hiropay-api.fly.dev'
if (location.hostname === "localhost") {
            server= 'http://localhost:4000'
          }

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';


export default {
  components: {
    vueDropzone: vue2Dropzone,
    VuePhoneNumberInput
  },
  data() {
    return {
      firstName: "",
      notice:false,
      step:1,
      lastName:"",
      country:"",
      city:"",
      id_number:"",
      file:'',
      phone:"",
      value:"",
      loading:false,
      valid_phone:false,
      show_verification:false,
      submited: false,
      password: "",
      recto: "",
      dropzoneOptions: {
          url: server+"/upload_file/file",
          thumbnailWidth: 150,
          maxFilesize: 5,
          maxFiles:1,
          addRemoveLinks:true,
          autoProcessQueue: false,
          dictDefaultMessage:'Cliquer pour Choisir un fichier',
          dictRemoveFile:'supprimer',
          dictCancelUpload : "annuler l'envoi",
          dictCancelUploadConfirmation :"Vous voulez vraiment annuler l'envoi?",
          headers: { "My-Awesome-Header": "header value" },
      },
      fetch_country:true,
      translations:{
        countrySelectorLabel: 'Code pays',
        countrySelectorError: 'Choisir un pays',
        phoneNumberLabel: 'Numéro de téléphone',
        example: 'Exemple :'
      }
    };
  },
  computed: {
    user() {
      let user = firebase.auth().currentUser;
      return {user_id: user.uid, email:user.email}
    },
    verified(){
      return this.verification? this.verification.status == 'complete': false
    },
    awaiting () {
      return this.verification?  this.verification.status == 'attente'&&this.verification.recto &&this.verification.selfie:false
    },

    ...mapGetters({
      user_data:"authfb/user",
      verification:"authfb/verification",

    })
   
  },
  created () {
    this.init();
    this.bind_verification()
  },
  async mounted () {
    let user = firebase.auth().currentUser;
    console.log(user.uid);
    let reference = db.collection('revoked_verification').where('user_id','==',user.uid )
    let snapshot  = await reference.get()
    
    if (!snapshot.empty) {
      console.log('found');
     
      this.notice = true
    }else{
      console.log('not revoked');
    }

  },
  
  methods: {
    send_recto() {
      const myVueDropzone= this.$refs.myVueDropzone
     myVueDropzone.processQueue()
    },

    set_step(){
      
      let count
      this.notice = false
      let data = this.$store.getters['authfb/verification']
     if (data) {
       let contain = (key)=>{
        return key in data
      }
       switch (true) {
        case !contain('info') &&!contain('recto')&&!contain('selfie'): count= 1
          break;
        case contain('info')&&!contain('recto')&&!contain('selfie'): count= 2
          break;
        case contain('info')&&!contain('recto')&&contain('selfie'): count= 2
          break;

        case contain('info')&&contain('recto')&&!contain('selfie'): count= 3
          break;
        default:count =1
          break;
      }
      console.log(count);
      this.step = count
     }
    
      this.show_verification = true
    
    },

    send_selfie() {
      const myVueDropzone= this.$refs.myVueDropzone_selfie
     myVueDropzone.processQueue()
    },
    
    async fileAdded(file){
      this.file =file
      const myVueDropzone= this.$refs.myVueDropzone
      //await myVueDropzone.removeAllFiles()
      console.log(myVueDropzone.getQueuedFiles());
      let queued_files = myVueDropzone.getQueuedFiles()
      queued_files.forEach(file => {
        myVueDropzone.removeFile(file)
      });
      let list = document.querySelectorAll('.dz-preview')
      if (list.length>1) {
        list[0].parentNode.removeChild(list[0]);
      }
    },

    async fileAdded_selfie(file){
      this.file =file
      const myVueDropzone= this.$refs.myVueDropzone_selfie
      //await myVueDropzone.removeAllFiles()
      console.log(myVueDropzone.getQueuedFiles());
      let queued_files = myVueDropzone.getQueuedFiles()
      queued_files.forEach(file => {
        myVueDropzone.removeFile(file)
      });
      let list = document.querySelectorAll('.dz-preview')
      if (list.length>1) {
        list[0].parentNode.removeChild(list[0]);
      }
    },


    successResponse(file, response){
      console.log(response);
      let list = document.querySelectorAll('.dz-preview')
      list[0].parentNode.removeChild(list[0]);
      this.step++
    },

    successResponse_selfie(file, response){
      let list = document.querySelectorAll('.dz-preview')
      //list[0].parentNode.removeChild(list[0]);
      //this.submited = true
    },
    
    sending(file, xhr,data) {
      const myVueDropzone= this.$refs.myVueDropzone
      //await myVueDropzone.removeAllFiles()
      data.append('user', this.user.user_id)
       data.append('doc_name','recto')
    },

    sending_selfie(file, xhr,data) {
      const myVueDropzone= this.$refs.myVueDropzone_selfie
      //await myVueDropzone.removeAllFiles()
      data.append('user', this.user.user_id)
       data.append('doc_name','selfie')
    },

    submit_info(){
        if (this.valid_phone && this.id_number.length>=6&& this.firstName.length>=3 && this.lastName.length>=3 && this.city.length>=2) {
          let data = {
          lastName: this.lastName.toUpperCase(),
          firstName: this.firstName,
          country: this.country,
          city: this.city,
          cphone: this.phone,
          id_number: this.id_number,
          user:this.user.user_id,
          email:this.user.email
        };
         console.log(data);
         let url= server
         if (location.hostname === "localhost") {
            // url= 'http://localhost:4000'
          }
          this.loading =  true;
         axios.post(url+'/upload_file/post_info', data).then(response => {
           this.loading = false
           let {data} = response
           console.log(data);
           if (data == 'success') {
             this.step++
           }
         })
        }else{
          alert('veuillez saisir toutes les informations')
        }
    },
    input_data(data){
      this.valid_phone = false
      let  countries = {
    "AF": "Afghanistan",
    "AX": "Aland Islands",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia",
    "BQ": "Bonaire, Sint Eustatius and Saba",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BV": "Bouvet Island",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "CV": "Cape Verde",
    "KY": "Cayman Islands",
    "CF": "Central African Republic",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands",
    "CO": "Colombia",
    "KM": "Comoros",
    "CG": "Congo",
    "CD": "Congo, the Democratic Republic of the",
    "CK": "Cook Islands",
    "CR": "Costa Rica",
    "CI": "Cote D'Ivoire",
    "HR": "Croatia",
    "CU": "Cuba",
    "CW": "Curacao",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "ET": "Ethiopia",
    "FK": "Falkland Islands (Malvinas)",
    "FO": "Faroe Islands",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "TF": "French Southern Territories",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HM": "Heard Island and Mcdonald Islands",
    "VA": "Holy See (Vatican City State)",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran, Islamic Republic of",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IM": "Isle of Man",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JE": "Jersey",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KP": "Korea, Democratic People's Republic of",
    "KR": "Korea, Republic of",
    "XK": "Kosovo",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Lao People's Democratic Republic",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libyan Arab Jamahiriya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macao",
    "MK": "Macedonia, the Former Yugoslav Republic of",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia, Federated States of",
    "MD": "Moldova, Republic of",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands",
    "AN": "Netherlands Antilles",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MP": "Northern Mariana Islands",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestinian Territory, Occupied",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "RU": "Russian Federation",
    "RW": "Rwanda",
    "BL": "Saint Barthelemy",
    "SH": "Saint Helena",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "MF": "Saint Martin",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tome and Principe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "RS": "Serbia",
    "CS": "Serbia and Montenegro",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SX": "Sint Maarten",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "GS": "South Georgia and the South Sandwich Islands",
    "SS": "South Sudan",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Svalbard and Jan Mayen",
    "SZ": "Swaziland",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syrian Arab Republic",
    "TW": "Taiwan, Province of China",
    "TJ": "Tajikistan",
    "TZ": "Tanzania, United Republic of",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks and Caicos Islands",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "GB": "United Kingdom",
    "US": "United States",
    "UM": "United States Minor Outlying Islands",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela",
    "VN": "Viet Nam",
    "VG": "Virgin Islands, British",
    "VI": "Virgin Islands, U.s.",
    "WF": "Wallis and Futuna",
    "EH": "Western Sahara",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
          };
          let {countryCode,isValid}= data
          let country = countries[countryCode]
          this.country = country
          console.log(country);
          if (isValid) {
            this.valid_phone = true
            let {formattedNumber,nationalNumber} =data
            this.phone = formattedNumber
          }
    },

    ...mapActions("authfb", ["init",]),
    ...mapActions("authfb", ["bind_verification"])



  },
};
</script>

<style lang="scss" scoped>
</style>